import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumberWithError } from 'libphonenumber-js';

@Pipe({
  name: 'formatPhonenumber',
  standalone: false,
})
export class PhonenumberFormatPipe implements PipeTransform {
  transform(pn: string): string {
    if (pn) return parsePhoneNumberWithError(pn, 'SE').formatInternational();
  }
}
